import React, { Component } from 'react';


class ScrollModifier extends Component {

  lastScroll=0;
  scrolled=0;

  constructor(props) {
    super(props);
  }

  componentDidMount() {

    window.addEventListener('scroll',this.scroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll',this.scroll)
  }

  scroll = () => {

  

    if(window.scrollY > this.lastScroll && !this.scrolled){
      this.scrolled = 1;
      window.site.modify('scrolled');
    }

    if(!this.props.hasOwnProperty('reverse') || this.props.hasOwnProperty('reverse') && this.props.reverse){
      if(window.scrollY <= this.lastScroll && this.scrolled){
        this.scrolled = 0;
        window.site.deModify('scrolled');
      }
    }else{
      if((window.scrollY <= 10) && this.scrolled){
         this.scrolled = 0;
          window.site.deModify('scrolled');
      }
    }



    this.lastScroll = window.scrollY;

  }

  /*

    RENDER

  */

  render() {

    return (
      
      this.props.children || null

    
    );

  }
}

export default ScrollModifier;



// WEBPACK FOOTER //
// ./src/js/_core/components/ScrollModifier/ScrollModifier.jsx